import { Box, Tab, Tabs } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { WORK_ORDER_DETAIL_TABS, WorkOrderDetailTab } from "../types";
import { useStyles } from "./styles";

type Props = {
  value: WorkOrderDetailTab;
  onChange: (value: WorkOrderDetailTab) => void;
};

const DetailTabs = ({ value, onChange }: Props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const isHebrew = (i18n.language || "hw").startsWith("hw");

  const tabsToRender = useMemo(
    () => (isHebrew ? [...WORK_ORDER_DETAIL_TABS].reverse() : WORK_ORDER_DETAIL_TABS),
    [isHebrew]
  );

  return (
    <Box className={styles.tabBarRow}>
      <Box className={styles.tabsWrapper}>
        <Tabs
          className={styles.tabs}
          value={value}
          onChange={(_, nextValue) => onChange(nextValue as WorkOrderDetailTab)}
          variant="scrollable"
          scrollButtons={false}
        >
          {tabsToRender.map((tab) => (
            <Tab
              key={tab.id}
              label={t(tab.labelKey)}
              value={WorkOrderDetailTab[tab.id as keyof typeof WorkOrderDetailTab]}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default DetailTabs;
